export default class DepartmentService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllDepartments(args) {
    return this.axiosIns.get(this.serviceConfig.departments, { params: args });
  }

  createDepartments(...args) {
    return this.axiosIns.post(this.serviceConfig.departments, ...args);
  }

  editDepartments(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.departments}/${id}`, args);
  }

  getDepartment(departmentId) {
    return this.axiosIns.get(`${this.serviceConfig.departments}/${departmentId}`);
  }

  deleteDepartment(id) {
    return this.axiosIns.delete(`${this.serviceConfig.departments}/${id}`);
  }

  getDepartmentRuleSets(id) {
    return this.axiosIns.get(`${this.serviceConfig.departments}/${id}/rules`);
  }

  createDepartmentRule(id, ...args) {
    return this.axiosIns.post(`${this.serviceConfig.departments}/${id}/rules`, ...args);
  }

  getDepartmentRuleKey() {
    return this.axiosIns.get(`${this.serviceConfig.departments}/rules/keys?limit=1000`);
  }

  getDepartmentRuleType() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Department/DepartmentRuleType`
    );
  }

  getDepartmentRuleCondition() {
    return this.axiosIns.get(
      `${this.serviceConfig.constantEndpoint}/Department/DepartmentRuleCondition`
    );
  }

  getDepartmentRule(ruleId) {
    return this.axiosIns.get(`${this.serviceConfig.departments}/rules/${ruleId}`);
  }

  editDepartmentRule(id, ruleId, args) {
    return this.axiosIns.put(`${this.serviceConfig.departments}/${id}/rules/${ruleId}`, args);
  }

  deleteDepartmentRule(id) {
    return this.axiosIns.delete(`${this.serviceConfig.departments}/rules/${id}`);
  }
}
